module.exports = __webpack_public_path__ + "img/transportation.2c6de5c0.svg";